import { render, staticRenderFns } from "./wiki.vue?vue&type=template&id=1b0ab7ba&"
import script from "./wiki.vue?vue&type=script&lang=js&"
export * from "./wiki.vue?vue&type=script&lang=js&"
import style0 from "./wiki.vue?vue&type=style&index=0&id=1b0ab7ba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports